<template>
    <div id="campaign_create" class="fleet-form-main">
      <div :class="`loader${loaderClass}`" v-show="loading"></div>
      <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="canAccessPage === true">
            <div class="page-name">
                <span class="page-title" id="customerHeader1" v-if="isEdit" >Update Campaign</span>
                <span class="page-title" id="customerHeader2"  v-else>Add Campaign</span>
                <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="goPreviousPath" >
                    <i class="fp-back"> </i>  Back
                </button>
            </div>
            <div class="container-fluid">
                <div class="from-group">
                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <strong id="errorMsg" class="field-error"></strong>
                    </div>
                </div>
                <div class="admin-page-content customer-crud">
                    <section class="internal-container border-top-table-fl">
                      <div class="stepwizard">
                        <div class="stepwizard-row setup-panel">
                          <div class="stepwizard-step cursor-pointer" v-on:click.prevent="gotoNextStep('step-vin',true)">
                            <a href="#step-vin"  type="button" class="btn btn-primary btn-circle" id="vin">1</a>
                            <p>VIN Numbers</p>
                          </div>
                          <div class="stepwizard-step cursor-pointer" v-on:click.prevent="gotoNextStep('step-details',true)">
                            <a href="#step-details"  type="button" class="btn btn-tertiary btn-circle"  id="details">2</a>
                            <p>Details</p>
                          </div>
                          <div class="stepwizard-step cursor-pointer" v-on:click.prevent="gotoNextStep('step-docs',true)">
                            <a href="#step-docs"  type="button" class="btn btn-tertiary btn-circle" id="docs" >3</a>
                            <p>Documents</p>
                          </div>
                        </div>
                      </div>
                      <section>
                        <form autocomplete="off" class="needs-validation" novalidate id="CampaignForm">
                          <div v-if="step == 'step-vin'" class="setup-content setup-content1 basic-info"  id="step-vin">
                            <div style="display: flex; flex-direction: column;align-items: center">
                              <h3 class="color-darkblue">VIN Numbers</h3>
                              <div style="border: 3px solid #098de1; padding: 15px">
                                <h4>Select file for import</h4>
                                <form id="importFile" class="addinspectionForm">
                                  <div class="form-row">
                                    <div class="col form-group">
                                      <label class="control-label require mb-2" for="name">File:</label><br/>
                                      <input id="dnFile" type="file" @change="onFileChanged">
                                      <div class="field-error">{{import_error}}</div>
                                    </div>
                                  </div>
                                  <div class="form-row" v-if="importedFileName !== ''">
                                    <div class="col form-group">
                                      <label class="control-label"> Imported File </label>
                                      <span><i class="fp-text-document"></i> {{importedFileName}}</span>
                                    </div>
                                  </div>
                                  <div class="form-row">
                                    <div class="col form-group">
                                      <label class="control-label"> Download Sample file </label>
                                      <a href="javascript:void(0)" v-on:click="generateExcelSample()"> <i class="fp-text-document"></i> {{sampleFileName}} </a>
                                    </div>
                                  </div>
                                  <span class="field-error" style="margin: 0px">Please use a different browser, if the sample file download does not work.</span>
                                  <div class="pt-1">
                                    <button class="btn btn-primary" id="importButton" v-on:click.prevent="importItem()"> <i class="fp-import"> </i> Import</button>
                                  </div>
                                </form>
                              </div>
                              <div v-if="rows.length > 0" style="width: 33%; margin-top: 15px">
                                <h5 class="color-blue font-bold"> <i class="fp-vehicle">Imported VIN Numbers</i></h5>
                                <div class="table-responsive-sm">
                                  <table class="table table-bordered font-1">
                                    <thead>
                                    <tr class="table-primary">
                                      <th>Vin</th>
                                      <th>Status</th>
                                      <th>Uploaded At</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(row,key) in rows">
                                      <td>{{row.vin}}</td>
                                      <td>{{row.status}}</td>
                                      <td>{{row.uploaded_at}}</td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                            <div class="btn-groups mt-3">
                              <section>
                                <div class="btn-groups">
                                  <button class="btn btn-primary btn-text-indent ml-1" type="button" v-on:click.prevent="gotoNextStep('step-details')">Next <i
                                    class="fp-right-arrow right-icon"></i></button>
                                </div>
                              </section>
                            </div>
                          </div>
                          <div v-else-if="step == 'step-details'" class="setup-content setup-content2 basic-info hidden" id="step-details">
                            <h3 class="color-darkblue">Details</h3>
                            <section>
                              <div class="form-row">
                                <div class="col-4 form-group">
                                  <label class="control-label require" for="ffp_code">Campaign/ FFP code:</label>
                                  <span style="font-size: 14px;">{{ FFPCodeCharCount }}/100</span>
                                  <input type="text" class="form-control" v-model="ffp_code" id="ffp_code" placeholder="Enter Campaign/ FFP code" name="ffp_code">
                                  <div class="field-error">{{ ffp_code_error_msg }}</div>
                                </div>
                                <div class="col-4 form-group">
                                  <label class="control-label require" for="ffp_description">FFP Description:</label>
                                  <span style="font-size: 14px;">{{ FFPDescCharCount }}/100</span>
                                  <input type="text" class="form-control" v-model="ffp_description" id="ffp_description" placeholder="Enter FFP Description" name="ffp_description">
                                  <div class="field-error">{{ ffp_description_error_msg }}</div>
                                </div>
                              </div>
                              <div class="form-row">
                                <div class="col-4 form-group">
                                  <label class="control-label require" for="campaign_type">Campaign Type:</label>
                                  <v-select v-model="campaign_type" name="campaign_type" placeholder="Select Campaign Type."
                                            label="text" :options="campaignTypeArr">
                                  </v-select>
                                  <div class="field-error">{{campaign_type_error_msg}}</div>
                                </div>
                                <div class="col-4 form-group">
                                  <label class="control-label require" for="campaign_status">Campaign Status:</label>
                                  <v-select v-model="campaign_status" name="campaign_type" placeholder="Select Campaign Status."
                                            label="text" :options="campaignStatusArr">
                                  </v-select>
                                  <div class="field-error">{{campaign_status_error_msg}}</div>
                                </div>
                              </div>
                              <div class="form-row">
                                <div class="col-4 form-group">
                                  <label class="control-label require" for="campaign_start_date">Campaign Start Date:</label>
                                  <date-picker placeholder="MM/DD/YYYY" id="campaign_start_date" name="campaign_start_date"
                                               v-model="campaign_start_date"
                                               :config="options"></date-picker>
                                  <div class="field-error">{{campaign_start_date_error_msg}}</div>
                                </div>
                                <div class="col-4 form-group">
                                  <label class="control-label require" for="campaign_end_date">Campaign End Date:</label>
                                  <date-picker placeholder="MM/DD/YYYY" id="campaign_end_date" name="campaign_end_date"
                                               v-model="campaign_end_date"
                                               :config="endOptions" :disabled="disableEndDateField"></date-picker>
                                  <div class="field-error">{{campaign_end_date_error_msg}}</div>
                                </div>
                              </div>
                            </section>
                            <div class="btn-groups mt-3">
                              <button class="btn btn-primary btn-text-indent" type="button" v-on:click.prevent="gotoNextStep('step-vin')"><i
                                class="fp-left-arrow left-icon"></i>Previous</button>
                              <button class="btn btn-primary btn-text-indent" type="button" v-on:click.prevent="gotoNextStep('step-docs')">Next <i
                                class="fp-right-arrow right-icon"></i></button>
                            </div>
                          </div>
                          <div v-else class="setup-content setup-content3 basic-info hidden" id="step-docs">
                            <h3 class="color-darkblue">Documents</h3>
                            <section>
                              <DropZone 
                                  :showDropzone="dropZonePreviewFiles.length < 10"
                                  :showUploadedFiles="dropZonePreviewFiles.length > 0 && isEdit"
                                  :maxFileLimit='10'
                                  :docErrorMsg="doc_error_msg"
                                  :dropzoneRequired="dropZonePreviewFiles.length == 0"
                                  :dropZonePreviewFiles="dropZonePreviewFiles"
                                  :isEdit="isEdit"
                                  :needToCalculateMaxFile="true"
                                  @dropzone-update-files="updateFiles"
                                  @dropzone-remove-files="removeFiles"
                              />
                            </section>
                            <div class="btn-groups mt-3">
                              <button class="btn btn-primary btn-text-indent" type="button" v-on:click.prevent="gotoNextStep('step-details')"><i
                                class="fp-left-arrow left-icon"></i>Previous</button>
                              <button type="submit" id="CreateCampaignBtn" v-if="isEdit" class="btn btn-primary" v-on:click.prevent="CreateCampaign" >
                                <i class="fp-reload"> </i>  Update
                              </button>
                              <button type="submit" id="CreateCampaignBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateCampaign" >
                                <i class="fp-save"> </i>  Save
                              </button>
                              <button  type="submit" id="createAndContinueCampaignBtn" v-if="!isEdit" class="btn btn-tertiary" v-on:click.prevent="CreateCampaign(flag='Save and Continue')" >
                                <i class="fp-save-continue"> </i>  Save and Continue
                              </button>
                              <button type="submit" id="cancelCampaignBtn" class="btn btn-tertiary" v-on:click.prevent="goPreviousPath" >
                                <i class="fp-close"> </i>  Cancel
                              </button>
                            </div>
                          </div>
                        </form>
                      </section>
                    </section>
                </div>
            </div>
        </template>
        <template v-else-if="canAccessPage === false">
          <div class="container-fluid">
            <div class="bg-white text-center">
              <h1>
                Oops!</h1>
              <h2>
                403 </h2>
              <div class="error-details">
                Sorry!, You don't have permission to access this page.
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <loading-content></loading-content>
        </template>
        <app-footer></app-footer>
      </div>
    </div>
</template>
<script>
  import {commonMixins} from '../../mixins/commonMixins';
  import {contractMixins} from '../../mixins/contractMixins';
  import moment from 'moment';
  import DropZone from '../DropZone.vue';

  export default {
    name: "CampaignCreate",
    components: {DropZone},
    metaInfo() {
      return {
        title: (this.isEdit == true)? "Update Campaign | " + process.env.COPYRIGHT_NAME : "Create Campaign | " +process.env.COPYRIGHT_NAME
      }
    },

    mixins:[commonMixins,contractMixins],
    data: () => ({
        userId:0,
        permissions: [],
        canAccessPage: "",
        loading: false,
        options: {
            format: 'MM/DD/YYYY',
            useCurrent: true,
        },
        endOptions: {
            format: 'MM/DD/YYYY',
            useCurrent: false,
            minDate: '12/12/1999', // just a placeholder
        },
        campaignId: 0,
        ffp_code: "",
        ffp_description: "",
        campaign_type: [],
        vehicles: [],
        campaignTypeArr: [
            {value: "campaign", text: "Campaign"},
            {value: "recall", text: "Recall"},
        ],
        campaign_status: "",
        campaignStatusArr: [
            {value: "active", text: "Active"},
            {value: "inactive", text: "Inactive"},
        ],
        campaign_start_date: "",
        campaign_end_date: "",
        errorMsg: "",
        disableEndDateField: true,
        isEdit: false,
        ffp_code_error_msg: "",
        ffp_description_error_msg: "",
        campaign_type_error_msg: "",
        campaign_status_error_msg: "",
        campaign_start_date_error_msg: "",
        campaign_end_date_error_msg: "",
        velocity_env:process.env.NODE_ENV,
        vinArr:[],
        rows: [],
        removedFiles: [],
        dropZonePreviewFiles: [],
        doc_error_msg: "",
        files: [],
        sampleFileName: 'VIN Sample',
        document_title_count: 0,
        selectedFile: [],
        import_error: "",
        step: "step-vin",
        lastFilledStep: false,
        importSuccess: false,
        FFPCodeCharCount: 0,
        FFPDescCharCount: 0,
        checkDuplicateVins: [],
        import_log_id: 0,
        allowToNextPage: false,
        navigateStepperFreely: false,
        importedFileName: '',
    }),

    watch:{
      //check permission change
      permissions: function (permissions) {
        var self = this;
        if (permissions.length > 0) {
          self.canAccessPage = false;
          for (var i = 0; i < permissions.length; i++) {
            if (permissions[i].name == 'ev_add_campaign' || permissions[i].name == 'ev_edit_campaign') {
              self.canAccessPage = true;
            }
          }
        }
      },
      campaign_start_date: function (value) {
        var self = this;
        if(value != "" && value != null){
          self.disableEndDateField = false;
          self.endOptions.minDate = value;
        }else{
          self.disableEndDateField = true;
          self.campaign_end_date = '';
        }

        if(self.campaign_start_date && self.campaign_end_date && self.campaign_end_date < self.campaign_start_date){
          self.campaign_end_date = '';
        }
      },
      ffp_code: function (value) {
        var self = this;
        if(value.length > 0){
          this.ffp_code_error_msg = "";
        }
        if (value.length > 100) {
          this.ffp_code = value.substring(0, 100);
        }
        this.FFPCodeCharCount = value.length;
      },
      ffp_description: function (value) {
        var self = this;
        if(value.length > 0){
          this.ffp_description_error_msg = "";
        }
        if (value.length > 100) {
          this.ffp_description = value.substring(0, 100);
        }
        this.FFPDescCharCount = value.length;
      },
      files: function(){
        this.fileErrorMsg = "";
      },
    },
    mounted: function() {
        var self = this;
        self.getPermissions();

        var userObj = JSON.parse(localStorage.getItem("user_obj"));
        if (userObj != null) {
          self.userId = userObj.id;
        }

        if (self.$route.params.id !== undefined && self.$route.params.id > 0) {
            self.campaignId = self.$route.params.id;
            self.loadSingleCampaign();
        }

       self.getCampaignVehicleList();
    },
    methods: {
        getCampaignVehicleList(){
          var self = this;
          self.loading = true;
          $.ajax({
            url: process.env.ROOT_API + "/asset-campaign/list",
            type: "GET",
            headers: this.ajxHeaders,
            data: {
              campaign_id: self.campaignId,
              userId: self.userId,
            },
            dataType: "json",
            success: function (data) {
              self.loading = false;
              if(data.status == 'success'){
                var dataSet = data.content;
                if(dataSet.length > 0){
                  for (var i =0; i < dataSet.length; i++){
                    if(!self.checkDuplicateVins.includes(dataSet[i].vin)){
                      self.rows.push({
                        id: dataSet[i].id,
                        vin: dataSet[i].vin,
                        uploaded_at: dataSet[i].uploaded_at != undefined ? dataSet[i].uploaded_at : '-',
                        vin_error_msg: "",
                        status: 'Imported'
                      });
                      self.checkDuplicateVins.push(dataSet[i].vin);
                    }
                  }
                  self.allowToNextPage = true;
                }
              }
            },
            error: function (jqXHR, exception) {
              self.loading = false;
              self.generateStatusCodeMessage(jqXHR,true,'get-campaign-vehicle-list');
            }
          });
        },
        updateFiles(files) {
            this.files = files;
        },
        removeFiles(removedFiles) {
            this.removedFiles = removedFiles;            
        },
        gotoNextStep: function (flag, stepper = false) {
          var self = this;
          if(self.allowToNextPage){
            if(flag == 'step-vin'){
              $('#details').removeClass('btn-primary').addClass('btn-tertiary');
              $('#docs').removeClass('btn-primary').addClass('btn-tertiary');
              $('#vin').removeClass('btn-tertiary').addClass('btn-primary');
            }

            if (flag == 'step-details') {
              if (stepper && self.lastFilledStep === false && !self.navigateStepperFreely){
                return false;
              }
              if (self.rows.length < 1) {
                alert('Please import the file with VIN numbers before continuing to next step.');
                return false;
              }
              $('#vin').removeClass('btn-primary').addClass('btn-tertiary');
              $('#docs').removeClass('btn-primary').addClass('btn-tertiary');
              $('#details').removeClass('btn-tertiary').addClass('btn-primary');
              self.lastFilledStep = 'step-vin';
            }

            if (flag == 'step-docs') {
              if (stepper && (self.lastFilledStep === 'step-vin' || self.lastFilledStep === false) && !self.navigateStepperFreely) {
                return false;
              }
              if (self.rows.length < 1) {
                alert('Please add at least one VIN number and fill required fields first.');
                return false;
              }
              var error = self.validateFields();
              if (error) {
                return false;
              }
              $('#vin').removeClass('btn-primary').addClass('btn-tertiary');
              $('#details').removeClass('btn-primary').addClass('btn-tertiary');
              $('#docs').removeClass('btn-tertiary').addClass('btn-primary');
              self.lastFilledStep = 'step-details';
              self.navigateStepperFreely = true;
            }

            self.step = flag;
          }else{
            self.$swal('','At least one VIN number should be imported.','warning');
          }
        },
        validateFields(){
            var self = this;

            var error = false;

            self.fileErrorMsg = "";
            self.ffp_code_error_msg = "";
            self.ffp_description_error_msg = "";
            self.campaign_type_error_msg = "";
            self.campaign_status_error_msg = "";
            self.campaign_start_date_error_msg = "";
            self.campaign_end_date_error_msg = "";

            if (self.ffp_code == null || self.ffp_code == '') {
                self.ffp_code_error_msg = "FFP Code is Required.";
                error = true;
            }
            if (self.ffp_code.length>100) {
              self.ffp_code_error_msg = "FFP Code must be less than 100 Characters.";
              error = true;
            }

            if (self.ffp_description == null || self.ffp_description == '') {
                self.ffp_description_error_msg = "FFP Description is Required.";
                error = true;
            }
            if (self.ffp_description.length>100) {
              self.ffp_description_error_msg = "FFP Description must be less than 100 Characters.";
              error = true;
            }

            if (self.campaign_type == null || self.campaign_type == '') {
                self.campaign_type_error_msg = "Campaign Type is Required.";
                error = true;
            }
            if (self.campaign_status == null || self.campaign_status == '') {
                self.campaign_status_error_msg = "Campaign Status is Required.";
                error = true;
            }
            if (self.campaign_start_date == null || self.campaign_start_date == '') {
                self.campaign_start_date_error_msg = "Campaign Start Date is Required.";
                error = true;
            }
            if (self.campaign_end_date == null || self.campaign_end_date == '') {
                self.campaign_end_date_error_msg = "Campaign End Date is Required.";
                error = true;
            }

            return error;
        },
        CreateCampaign(flag){
            var self = this;
            var error = self.validateFields();
            // check if file is uploaded
            if (!self.isEdit && self.files.length == 0) {
              self.doc_error_msg = "Document is Required.";
              error = true;
            }
            if(!error){
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/campaign/create",
                    type: "POST",
                    headers: this.ajxHeaders,
                    data: {
                        removed_files: self.removedFiles,
                        is_edit: self.isEdit,
                        id: self.campaignId,
                        ffp_code: self.ffp_code,
                        ffp_description: self.ffp_description,
                        campaign_type: self.campaign_type,
                        campaign_status: self.campaign_status,
                        campaign_start_date: self.campaign_start_date,
                        campaign_end_date: self.campaign_end_date,
                        vehicles: self.rows,
                        files: self.files,
                        log_id: self.import_log_id,
                    },
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if(data.status == 'success'){
                            if(flag == "Save and Continue"){
                              self.step = "step-vin";
                              self.rows = [];
                              self.selectedFile = '';
                              self.ffp_code = '';
                              self.ffp_description = '';
                              self.campaign_type = '';
                              self.campaign_status = '';
                              self.campaign_start_date = '';
                              self.campaign_end_date = '';
                              self.dropZonePreviewFiles = [];
                              self.files = [];
                              self.importedFileName = '';
                              self.navigateStepperFreely = false;
                              self.checkDuplicateVins = [];

                              $('#details').removeClass('btn-primary').addClass('btn-tertiary');
                              $('#docs').removeClass('btn-primary').addClass('btn-tertiary');
                              $('#vin').removeClass('btn-tertiary').addClass('btn-primary');

                              $("#CampaignForm").trigger("reset");
                            }else{
                                self.$router.push("/campaign/list");
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                self.$router.push("/");
                            }
                            $("#errorMsg").html(jqXHR.responseJSON.message);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                });
            }
        },
        loadSingleCampaign() {
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/campaign/" + self.campaignId,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        self.isEdit = true;
                        self.campaignId = data.content.id;
                        self.ffp_code = data.content.ffp_code;
                        self.ffp_description = data.content.ffp_description;
                        self.campaign_type = data.content.campaign_type;
                        self.campaign_status = data.content.campaign_status;
                        self.campaign_start_date = data.content.campaign_start_date;
                        self.campaign_end_date = data.content.campaign_end_date;
                        self.dropZonePreviewFiles = data.content.file_path_arr;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (jqXHR.status == 0) {
                        self.errorMsg = "Remote server can not be reachable";
                    } else {
                        //redirect to login page if user not authenticated
                        if (jqXHR.status == 401) {
                            //clear previous data
                            localStorage.removeItem("user_obj");
                            localStorage.removeItem("tkn");
                            self.$router.push("/");
                        }
                        $("#errorMsg").html(jqXHR.responseJSON.message);
                        $(".alert-warning").toggleClass("show");
                        setTimeout(function () {
                            $(".alert-warning").removeClass("show");
                            $(".alert-warning").addClass("hide");
                        }, 10000);
                    }
                }
            });
        },
        onSearchAssetWithVin(search, loading) {
          var self = this;
          if (search.length > 3) {
            loading(true);
            self.searchField(loading, search, 'vehicle_vin', '');
          }
        },

        addRow: function () {
          var self = this;
          var index=self.rows.length-1;
          var validate = false;

          if (index >= 0){
            if ((self.rows[index].vin != null && self.rows[index].vin != "") || index == -1){
              validate = true;
              self.rows[index].vin_error_msg = "";
            }
          }else {
            validate = true;
          }

          if (validate) {
            if (typeof self.rows == "string") {
              self.rows = [];
            }
            self.rows.push({
              id: "",
              vin: "",
              vin_error_msg: "",
            });
          } else {
            if (self.rows[index].vin == null || !self.rows[index].vin) {
              self.rows[index].vin_error_msg = "VIN is Required.";
            }
          }

        },
        removeElement: function (index) {
          var self = this;
          if (self.rows[index].vin == null || self.rows[index].vin == ""){
            self.rows.splice(index, 1);
            return true;
          }
          if(self.rows.length > 1)
          {
            if (confirm('Are you sure that you want to detach this vehicle from campaign? ')) {
              $.ajax({
                url: process.env.ROOT_API + "/remove_campaign_vehicles",
                type: "POST",
                data: {
                  'vehicle_id': self.rows[index].vin,
                  'campaign_id': self.campaignId,
                  'userId': self.userId,
                },
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                  if (data.status == "success") {
                    self.rows.splice(index, 1);
                  }
                },
                error: function (jqXHR, exception) {
                  self.generateStatusCodeMessage(jqXHR,true,'remove-customer-po-item');
                },
              });
            }
          }
        },
        openModal: function(){
          var self = this;
          self.selectedFile = [];
          // self.duplicatePolicy = [];
          $("#dnFile").val('');
          self.import_error = '';
          self.importIssue = [];
          $('#item-modal').modal('show');
        },
        generateExcelSample:function(){
          var self = this;
          self.loading = true;
          $.ajax({
            url:
              process.env.ROOT_API +
              "/campaign-vin-excel/generate",
            type: "POST",
            crossDomain: true,
            dataType: "json",
            headers: {
              'Accept': "application/json",
              "Access-Control-Allow-Origin": "*",
              'Authorization': "Bearer " + localStorage.getItem("tkn"),
              "Access-Control-Allow-Headers":
                "Origin, Content-Type, Authorization,X-Requested-With",
              "Cache-Control": "no-cache"
            },

            success: function(data) {
              self.loading = false;
              var docPath = data.content.web;
              var save = document.createElement('a');
              save.href = docPath;
              save.download = docPath;
              save.target = '_blank';
              document.body.appendChild(save);
              save.click();
              document.body.removeChild(save);
            },
            error: function(jqXHR, exception) {
              self.loading = false;
              self.generateStatusCodeMessage(jqXHR,true,'debt note-import')

            }
          });
        },
        onFileChanged(event) {
          const file = event.target.files[0];
          var self = this;
          self.selectedFile = file;
          self.import_error = '';
        },
        importItem(){
          var self = this;

          // var path = window.location.pathname;
          // var segments = path.split("/");

          self.import_error = "";
          if( self.selectedFile == "" || self.selectedFile == null){
            self.import_error = "Please Select Excel File.";
            return;
          }
          var fileExtension = ['xls', 'xlsx'];
          if ($.inArray(self.selectedFile.name.split('.').pop().toLowerCase(), fileExtension) == -1) {
            self.import_error = "Only the following file formats are allowed : "+fileExtension.join(', ');
            return;
          }

          var formData = new FormData();
          formData.append('myFile', self.selectedFile);
          formData.append('id', self.woId);

          self.loading = true;

          $.ajax({
            url: process.env.ROOT_API + "/campaign-vin/import?campaign="+self.campaignId,
            type: "POST",
            data: formData,
            headers: {
              "Accept": "application/json",
              "Access-Control-Allow-Origin": "*",
              "Authorization": "Bearer " + localStorage.getItem("tkn"),
              "Access-Control-Allow-Headers":
                "Origin, Content-Type, Authorization,X-Requested-With",
              "Cache-Control": "no-cache"
            },
            crossDomain: true,
            processData: false,
            contentType: false,
            dataType: "json",
            success: function (data) {
              self.loading = false;
              if(data.status == "success"){
                if (data.content != undefined && data.content.length > 0){
                  var dataSet = data.content;
                  self.import_log_id = data.import_log_id;
                  for (var i =0; i < dataSet.length; i++){
                    if(dataSet[i].status == 'Imported'){
                      self.allowToNextPage = true;
                    }
                    if(!self.checkDuplicateVins.includes(dataSet[i].vin)){
                      self.rows.push({
                        id: dataSet[i].id,
                        vin: dataSet[i].vin,
                        uploaded_at: dataSet[i].status == 'Imported' ? moment().format('MM/DD/YYYY') : '-',
                        vin_error_msg: "",
                        status: dataSet[i].status,
                      });
                      self.checkDuplicateVins.push(dataSet[i].vin);
                    }else{
                      self.rows.push({
                        id: dataSet[i].id,
                        vin: dataSet[i].vin,
                        uploaded_at: dataSet[i].status == 'Imported' ? moment().format('MM/DD/YYYY') : '-',
                        vin_error_msg: "",
                        status: "Duplicate",
                      });
                    }
                  }
                }
                self.importedFileName = data.file_name;
                self.importSuccess = true;
                self.$swal({
                    title: "File Uploaded Successfully.",
                    text: "The status of the uploaded VINs is displayed in the table below.",
                    type: "info",
                    confirmButtonText: "Ok",
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                })
              }else{
                self.import_error = data.message;
              }
            },
            error: function (jqXHR, exception) {
              self.loading = false;
              self.importedFileName = '';
              $('#importButton').text('Import');
              $('#importButton').prop('disabled',false);
              $('#cancelButton').prop('disabled',false);
              self.generateStatusCodeMessage(jqXHR,true,'policy-import-error')
            }
          });
        },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/campaign/CampaignCreate.vue